<ng-template #content>
  <div class="offcanvas-header p-2 justify-content-between">
    <p [attr.id]="menuTitle()" class="offcanvas-title h4">
      {{ menuTitle() }}
    </p>
    <crnt-button
      (click)="dismiss('close')"
      id="close"
      variant="tertiary"
      wlAutomationId="navigation-mobile-close-menu"
      tabindex="0"
      wlTrackLink
      [trackLinkInfo]="{
        rendering: { componentName: 'NavigationMobileComponent' },
        field: closeMenuButtonText(),
        eventType: 'button-click',
        type: 'button',
      }"
    >
      <span>{{ closeMenuButtonText() }}</span>
      <crnt-icon icon="xmark" slot="trailing" />
    </crnt-button>
  </div>
  <div class="offcanvas-body">
    <nav [attr.aria-labelledby]="this.menuTitle()">
      @for (navigationItem of navigationItems(); track navigationItem.name) {
        <wl-navigation-mobile-item
          (navigate)="this.dismiss('navigate')"
          [navigationItem]="navigationItem"
        />
      }
      @if (loginButton().url; as loginUrl) {
        <wl-navigation-service-button
          (navigate)="dismiss('navigate')"
          [href]="loginUrl"
          [text]="loginButton().text ?? 'Inloggen'"
          class="d-flex p-2 border-bottom"
          iconName="user"
          wlAutomationId="login-button"
        />
      }
    </nav>

    @if (domainNavigation()) {
      <wl-navigation-domain-links
        (navigate)="dismiss('navigate')"
        [navigationItems]="domainNavigation()"
        class="d-flex px-2 py-1 border-bottom"
        wlAutomationId="navigation-domain-links"
      />
    } @else {
      <div tabindex="0">
        <!-- The NgBootstrap focus-trap can not handle a <details> element as last focusable item.
             This is here so that we always have a valid last focusable element -->
        <crnt-visually-hidden>Einde van het menu</crnt-visually-hidden>
      </div>
    }
  </div>
</ng-template>

<crnt-button
  (click)="open(content)"
  variant="tertiary"
  aria-haspopup="menu"
  wlAutomationId="navigation-mobile-open-menu"
  wlTrackLink
  [trackLinkInfo]="{
    rendering: { componentName: 'NavigationMobileComponent' },
    field: openMenuButtonText(),
    eventType: 'button-click',
    type: 'button',
  }"
>
  <crnt-visually-hidden>
    {{ openMenuButtonText() }}
  </crnt-visually-hidden>
  <crnt-icon icon="bars" />
</crnt-button>
